import type { Category } from "@/types";

export const categories: Category[] = [
  {
    slug: "star",
    name: "明星八卦",
    desc: "娱乐圈一线动态、绯闻传闻与片场趣事，把台前幕后的蛛丝马迹替你理清楚。",
    icon: "ri-star-smile-line",
  },
  {
    slug: "influencer",
    name: "网红黑料",
    desc: "直播间翻车、带货争议与账号风波，记录达人生态里那些藏不住的名场面。",
    icon: "ri-live-line",
  },
  {
    slug: "society",
    name: "社会热点",
    desc: "全网热议的公共话题与生活观察，用冷静视角还原事件来龙去脉。",
    icon: "ri-earth-line",
  },
  {
    slug: "screen",
    name: "影视综艺",
    desc: "剧集幕后、综艺剪辑争议与评分风向，追剧党的每日情报补给站。",
    icon: "ri-film-line",
  },
  {
    slug: "emotion",
    name: "情感吐槽",
    desc: "恋爱观察、婚恋话题与人间真实，看别人故事谈自己的情绪账本。",
    icon: "ri-heart-3-line",
  },
];